<template>
  <a-modal v-model="showModal" @ok="() => (showModal = false)" title="Create Your Avatar" :footer="null" :centered="true" :dialog-style="{ margin: '0px', width: '100px !important' }">
    <div>
      <Avatar
        class="avatar-modal"
        :style="{ height: '250px', width: '100%' }"
        ref="avatar"
        :handleChange="handleChange"
        :circleColor="circleColor"
        :topType="top"
        topColor="#0d29db"
        :accessoriesType="accessories"
        :facialHairType="facialHair"
        :clotheType="cloth"
        :eyebrowType="eyeBrow"
        :eyeType="eye"
        :mouthType="mouth"
        :facialHairColor="faceColor"
        :graphicType="graphicType"
        :skinColor="skin"
      ></Avatar>
    </div>
    <div class="d-flex flex-wrap">
      <div class="m-2">
        <span>Circle Color</span>
        <AvatarDropDown :avatarOptions="cirColors" :handleOptionType="val => handleOptionType(val, 'color')" />
      </div>
      <div class="m-2">
        <span>Skin Color</span>
        <AvatarDropDown :avatarOptions="skinColors" :handleOptionType="val => handleOptionType(val, 'skin')" />
      </div>
      <div class="m-2">
        <span>Top </span>
        <AvatarDropDown :avatarOptions="topList" :handleOptionType="val => handleOptionType(val, 'top')" />
      </div>

      <div class="m-2">
        <span>Accessories</span>
        <AvatarDropDown :avatarOptions="accList" :handleOptionType="val => handleOptionType(val, 'accessories')" />
      </div>
      <div class="m-2">
        <span>Facial Hair</span>
        <AvatarDropDown :avatarOptions="facehairList" :handleOptionType="val => handleOptionType(val, 'facehair')" />
      </div>
      <div class="m-2">
        <span>Facial Hair color </span>
        <AvatarDropDown :avatarOptions="faceColorsList" :handleOptionType="val => handleOptionType(val, 'facehaircolor')" />
      </div>
      <div class="m-2">
        <span>Clothes</span>
        <AvatarDropDown :avatarOptions="clothsList" :handleOptionType="val => handleOptionType(val, 'cloths')" />
      </div>
      <div class="m-2">
        <span>Eye Brows</span>
        <AvatarDropDown :avatarOptions="eyebrowsList" :handleOptionType="val => handleOptionType(val, 'eyebrow')" />
      </div>
      <div class="m-2">
        <span>Eyes</span>
        <AvatarDropDown :avatarOptions="eyesList" :handleOptionType="val => handleOptionType(val, 'eye')" />
      </div>
      <div class="m-2">
        <span>Mouth</span>
        <AvatarDropDown :avatarOptions="mouthsList" :handleOptionType="val => handleOptionType(val, 'mouth')" />
      </div>

      <div class="m-2">
        <span>Graphics</span>
        <AvatarDropDown :avatarOptions="graphicsList" :handleOptionType="val => handleOptionType(val, 'graphics')" />
      </div>
    </div>
    <div :style="{ 'text-align': 'center', 'margin-top': '30px' }">
      <div>
        <a-button
          key="submit"
          type="primary"
          class="primary-button"
          @click="handleRef"
          :style="{
            border: '1px solid ' + getPrimaryColor(),
            background: getPrimaryColor(),
            padding: '10px 40px',
            'border-radius': '25px',
          }"
          >Submit</a-button
        >
      </div>
    </div>
  </a-modal>
</template>

<script>
import Avatar from "vuejs-avatar-generator"
import AvatarDropDown from "./userAvatarDropDown.vue"

export default {
  name: "AvatarCreater",

  data() {
    return {
      showModal: false,
      // circleColor:'#551253',
      // top:'Hat',
      // accessories:'Kurt',
      // facialHair:'Blonde',
      // cloth:'GraphicShirt',
      // eyeBrow:'Angry',
      // eye:'Cry',
      // mouth:'Eating',
      // faceColor:'Blonde',
      // graphicType:'Cumbia',

      circleColor: null,
      top: null,
      accessories: null,
      facialHair: null,
      cloth: null,
      eyeBrow: null,
      eye: null,
      mouth: null,
      faceColor: null,
      graphicType: null,
      skin: "#ffdbb4",

      cirColors: [
        { label: "Light Blue", value: "#6fb8e0" },
        { label: "Purple", value: "#551253" },
        { label: "Blue", value: "#09389d" },
        { label: "Green", value: "#a9e965" },
        { label: "Sky Blue", value: "#2fa3b9" },
        { label: "Yellow", value: "#d7e048" },
      ],
      skinColors: [
        { label: "Ivory", value: "#ffdbb4" },
        { label: "Chocolate", value: "#592f2a" },
        { label: "Dark Chocolate", value: "#503335" },
        { label: "Umber", value: "#a1665e" },
        { label: "Porcelane", value: "#d1a3a4" },
        { label: "Senna", value: "#c58c85" },
      ],
      topList: [
        { label: "Turban", value: "Turban" },
        { label: "WinterHat1", value: "WinterHat1" },
        { label: "WinterHat2", value: "WinterHat2" },
        { label: "WinterHat3", value: "WinterHat3" },
        { label: "WinterHat4", value: "WinterHat4" },
        { label: "LongHairBigHair", value: "LongHairBigHair" },
        { label: "LongHairBob", value: "LongHairBob" },
        { label: "LongHairBun", value: "LongHairBun" },
        { label: "Hat", value: "Hat" },
        { label: "Eyepatch", value: "Eyepatch" },

        { label: "LongHairNotTooLong", value: "LongHairNotTooLong" },
      ],
      accList: [
        { label: "Blank", value: "Blank" },
        { label: "Kurt", value: "Kurt" },
        { label: "Prescription01", value: "Prescription01" },
        { label: "Round", value: "Round" },
        { label: "Sunglasses", value: "Sunglasses" },
        { label: "Wayfarers", value: "Wayfarers" },
      ],
      facehairList: [
        { label: "Blank", value: "Blank" },
        { label: "BeardMedium", value: "BeardMedium" },
        { label: "BeardLight", value: "BeardLight" },
        { label: "BeardMagestic", value: "BeardMagestic" },
        { label: "MoustacheFancy", value: "MoustacheFancy" },
        { label: "MoustacheMagnum", value: "MoustacheMagnum" },
      ],
      clothsList: [
        { label: "BlazerShirt", value: "BlazerShirt" },
        { label: "BlazerSweater", value: "BlazerSweater" },
        { label: "CollarSweater", value: "CollarSweater" },
        { label: "GraphicShirt", value: "GraphicShirt" },
        { label: "Hoodie", value: "Hoodie" },
        { label: "Overall", value: "Overall" },
        { label: "ShirtCrewNeck", value: "ShirtCrewNeck" },
        { label: "ShirtScoopNeck", value: "ShirtScoopNeck" },

        { label: "ShirtVNeck", value: "ShirtVNeck" },
      ],
      eyebrowsList: [
        { label: "Angry", value: "Angry" },
        { label: "DefaultNatural", value: "DefaultNatural" },
        { label: "FlatNatural", value: "FlatNatural" },
        { label: "RaisedExcited", value: "RaisedExcited" },
        { label: "SadConcernedNatural", value: "SadConcernedNatural" },
        { label: "UnibrowNatural", value: "UnibrowNatural" },
        { label: "UpDownNatural", value: "UpDownNatural" },
      ],
      eyesList: [
        { label: "Default", value: "Default" },
        { label: "Dizzy", value: "Dizzy" },
        { label: "EyeRoll", value: "EyeRoll" },
        { label: "Happy", value: "Happy" },
        { label: "Hearts", value: "Hearts" },
        { label: "Side", value: "Side" },
        { label: "Squint", value: "Squint" },
        { label: "Surprised", value: "Surprised" },
        { label: "Wink", value: "Wink" },
      ],
      mouthsList: [
        { label: "Eating", value: "Eating" },
        { label: "Grimace", value: "Grimace" },
        { label: "Sad", value: "Sad" },
        { label: "ScreamOpen", value: "ScreamOpen" },
        { label: "Serious", value: "Serious" },
        { label: "Smile", value: "Smile" },
        { label: "Tongue", value: "Tongue" },
        { label: "Twinkle", value: "Twinkle" },
      ],
      faceColorsList: [
        { label: "Platinum", value: "Platinum" },
        { label: "BlondeGolden", value: "BlondeGolden" },
        { label: "SilverGray", value: "SilverGray" },
        { label: "PastelPink", value: "PastelPink" },
        { label: "Blonde", value: "Blonde" },
        { label: "Black", value: "Black" },
      ],
      graphicsList: [
        { label: "Bat", value: "Bat" },
        { label: "Hola", value: "Hola" },
        { label: "Bear", value: "Bear" },
        { label: "Skull", value: "Skull" },
        { label: "Pizza", value: "Pizza" },
        { label: "Diamond", value: "Diamond" },
        { label: "Cumbia", value: "Cumbia" },
      ],
    }
  },

  created() {
    // console.log(this.$refs.Avatar, "avatar ref");
  },

  components: {
    Avatar,
    AvatarDropDown,
  },

  props: {
    handleProfilePic: Function,
  },

  methods: {
    show() {
      this.showModal = true
    },
    handleRef() {
      // console.log(this.$refs.avatar.$el, "avatar");
      this.handleProfilePic(this.$refs.avatar.$el)
      this.showModal = false
    },
    handleChange(val) {
      // console.log(val)
    },
    handleOptionType(option, type) {
      // console.log(option, type, "in avatar state")
      switch (type) {
        case "top":
          return (this.top = option)

        case "skin":
          return (this.skin = option)

        case "mouth":
          return (this.mouth = option)

        case "color":
          return (this.circleColor = option)

        case "accessories":
          return (this.accessories = option)

        case "facehair":
          return (this.facialHair = option)

        case "cloths":
          return (this.cloth = option)

        case "eyebrow":
          return (this.eyeBrow = option)

        case "eye":
          return (this.eye = option)

        case "facehaircolor":
          return (this.faceColor = option)

        case "graphics":
          return (this.graphicType = option)

        default:
          return
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-modal {
  height: 250px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/UserAvatarCreationModal.vue